__turbopack_context__.v({
  "btnLink": "styles-module-scss-module__Iaq2tG__btnLink",
  "content": "styles-module-scss-module__Iaq2tG__content",
  "description": "styles-module-scss-module__Iaq2tG__description",
  "root": "styles-module-scss-module__Iaq2tG__root",
  "title": "styles-module-scss-module__Iaq2tG__title",
});
